import React from 'react';
import '../grammar-page.css';
import { FaBookOpen, FaLightbulb } from 'react-icons/fa';

const PerfectPastExplanation = () => {
  return (
    <div className="grammar-explanation">
      <h2><FaBookOpen /> Present Perfect vs Simple Past</h2>

      <p>
        The <strong>present perfect</strong> and <strong>simple past</strong> tenses both talk about past actions, but they focus on different meanings:
      </p>

      <div className="example-block">
        <p><strong>Examples:</strong></p>
        <ul>
          <li><strong>I lived</strong> in Sacramento for 18 years. (Simple Past: I don't live there now.)</li>
          <li><strong>I have lived</strong> in Budapest for 33 years. (Present Perfect: I still live here.)</li>
        </ul>
      </div>

      <div className="grammar-explanation-grid">
        <div className="example-block">
          <h3><FaLightbulb /> Present Perfect Time Expressions</h3>
          <ul>
            <li><strong>for, since, yet, already</strong></li>
            <li>I have lived in Budapest <strong>for</strong> 33 years.</li>
            <li>I have lived on Pannonia <strong>since</strong> last summer.</li>
            <li>I haven't been to Switzerland <strong>yet</strong>.</li>
            <li>Have you tried making French baguettes <strong>yet</strong>?</li>
            <li>I have <strong>already</strong> been to France.</li>
          </ul>
        </div>

        <div className="example-block">
          <h3><FaLightbulb /> Simple Past Time Expressions</h3>
          <ul>
            <li><strong>for, when, ago, last, yesterday</strong></li>
            <li>I lived in Sacramento 33 years <strong>ago</strong>.</li>
            <li><strong>When</strong> I lived in Sacramento, I was still a teenager.</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default PerfectPastExplanation;
